import Vue from 'vue';
import Router from 'vue-router';

import index from '@/page/index';




Vue.use(Router);

export default new Router({
  // mode: 'history',
  // base: __dirname,
	base: '/bigScreen/',
  routes: [
    {
      name: '',
      path: '/',
      component: index,
      redirect: '/index'
    },{
			name: 'index',
			path: '/index',
			component: index,
			}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js